// extracted by mini-css-extract-plugin
export var dropdown = "_t0-0";
export var imageWrapper = "_t0-3";
export var itemNameContainer = "_t0-1";
export var productImage = "_t0-2";
export var spinnerWrapper = "_t0-4";